/* @ngInject */
export default function LiveSessionModel(
  $timeout,
  $uibModal,
  CurrentCourseManager,
  LiveSessionResources,
  TimelinesManager,
  moment,
) {
  class LiveSession {
    preprocessRecording() {
      if (this.recording?.file?.url) {
        if (this.recording.file.lowDefaultPlayback) {
          this.recording.file.lowQualityUrl = this.recording.file.url;
        }
        if (this.recording.file.mediumDefaultPlayback) {
          this.recording.file.mediumQualityUrl = this.recording.file.url;
        }
        if (this.recording.file.highDefaultPlayback) {
          this.recording.file.highQualityUrl = this.recording.file.url;
        }
      }
    }

    constructor(attributes) {
      Object.assign(this, attributes);
      this.preprocessRecording();
    }

    showDownloadLink() {
      const { file } = this.recording ?? {};
      return file && (file.isDownloadable || file.transcriptUrl || file.textTranscriptUrl || file.slidesUrl);
    }

    isCompleted() {
      return this.attendeeInfo && (this.attendeeInfo.status === 'attended_manual' || this.attendeeInfo.status === 'attended_auto' || this.attendeeInfo.status === 'watched_recording');
    }

    isMissed() {
      return this.attendeeInfo?.status === 'missed';
    }

    beginningSoon() {
      return !!this.startTime && moment(this.startTime) <= moment().add(10, 'minutes');
    }

    hasEnded() {
      return !!(this.startTime && this.duration && moment(this.startTime).add(this.duration, 'minutes') <= moment());
    }

    hasErrors() {
      return this.errorCode !== null && this.errorCode !== undefined && this.errorCode.code > 0;
    }

    validateEmails(emails) {
      return LiveSessionResources.validateStudents({ catalogId: CurrentCourseManager.course.catalogId, liveSessionId: this.id }, { emails })
        .$promise.then((response) => response.result);
    }

    dismissNotification() {
      return LiveSessionResources.dismissNotification({ catalogId: CurrentCourseManager.course.catalogId, liveSessionId: this.id }, {})
        .$promise.then((response) => response.result);
    }

    recordJoinIntention() {
      return LiveSessionResources.recordJoinIntention({ catalogId: CurrentCourseManager.course.catalogId, liveSessionId: this.id }, {})
        .$promise.then((response) => response.result);
    }

    uploadAttendance(attendees, overwrite_existing_attendees) {
      return LiveSessionResources.uploadSessionAttendance({ catalogId: CurrentCourseManager.course.catalogId, liveSessionId: this.id }, { attendees, overwrite_existing_attendees })
        .$promise.then((response) => response.result);
    }

    manualUploadRecording(unique_id, file_name) {
      const video = unique_id && file_name ? { unique_id, file_name } : null;
      return LiveSessionResources.uploadSessionRecording({ catalogId: CurrentCourseManager.course.catalogId, liveSessionId: this.id }, { video })
        .$promise.then((response) => {
          this.recording = response.result;
          this.preprocessRecording();
        });
    }

    recordingEventCallback(event, second, total, lecturePageId, componentId) {
      if (event !== 'unload' || second !== 0) {
        // we are currently using a get so the parameter is not converted
        this.lastEventCallbackPromise = LiveSessionResources.recordingWatchEvent({
          catalogId: CurrentCourseManager.course.catalogId,
          liveSessionId: this.id,
          second,
          video_action: event,
          total,
        }).$promise.then((response) => {
          const lectureVideo = response.result;

          if (lectureVideo.pointsReceived > this.pointsReceived) {
            TimelinesManager.updateComponentPointsAndProgress(lecturePageId, 'LiveSessionLectureComponent', componentId, lectureVideo.pointsReceived, lectureVideo.totalPoints[0]);
            this.pointsReceived = lectureVideo.pointsReceived;

            $uibModal.open({
              templateUrl: 'shared/templates/points-modal.html',
              windowClass: 'points-modal',
              controller: 'PointsModalCtrl as vm',
              resolve: {
                pointsReceived: lectureVideo.pointsReceived,
                leaderboardPoints: lectureVideo.leaderboardPoints,
                leaderboardRank: lectureVideo.leaderboardRank,
                priorLeaderboardRank: lectureVideo.priorLeaderboardRank,
                extras: null,
              },
            });
          }

          if (lectureVideo.attendeeInfo.status) {
            this.attendeeInfo.status = lectureVideo.attendeeInfo.status;
          }

          return this;
        });

        // the timecallback happens before the event callback sometimes
        $timeout(() => {
          this.startPlaybackFrom = second;
        });

        return this.lastEventCallbackPromise;
      }

      return null;
    }

    recordingTimeCallback(second) {
      this.startPlaybackFrom = second;
    }
  }

  return LiveSession;
}
